import { render, staticRenderFns } from "./UpdateFollowupStatusDialogCpt.vue?vue&type=template&id=773a5464&"
import script from "./UpdateFollowupStatusDialogCpt.vue?vue&type=script&lang=ts&"
export * from "./UpdateFollowupStatusDialogCpt.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateFollowupStatusDialogCpt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports